export default {
    component: () => import('./index'),
    meta: {
        nav: {
            title: '联系我们',
        }
    }
};
